import './modules/sticky-sidebar-component';

import { Header } from './modules/header';
import { HTMLVideoLoader, lazyPoster } from './helpers/video';
import { Modal } from './modules/a11y-modal';
import { Accordion } from './modules/accordion';
import { Alert } from './modules/ace-alert';
import { AutoplayVideo } from './modules/autoplay-video';
import { BrandVideo } from './modules/brand-video';
import { FiftyFifty } from './modules/fifty-fifty';
import { Gallery } from './modules/gallery';
import { Recommendation } from './modules/recommendation';
import { RevealPanel } from './modules/revealPanel';
import { showHidePassword } from './modules/show-hide-password';
import { SvgSprite } from './modules/svg-loader';
import { Tabs } from './modules/tabs';
import { reactToAutoplayFallbackFail } from './pages/homePage/heroBanner';
import { SiteSearch } from './modules/site-search';
import { quickDonate } from './pages/quickDonate/quickDonatePage';
import { AlertBlock } from './modules/alert-block';
import { Stepper } from './modules/stepper';
import { nodeListToArray } from './helpers/nodeListToArray';
import StrazCartTimer from './modules/cart-timer';
import { Toggletip } from './classes/toggletip';

new AlertBlock();

import AddressApi from './modules/address-api'
import { StateSummary } from './classes/address';
import { StateDropdown } from './modules/stateDropdown';


const init = () => {
    new StrazCartTimer();
    new SvgSprite('/Static/img/adage-sprite.svg');
    showHidePassword();
    quickDonate();
    initStateDropdowns();
}

const initializeGenericComponents = () => {
    new Header();

    const modals = Array.prototype.slice.call(document.querySelectorAll('[data-modal]')) as HTMLElement[];
    modals.forEach(modal => {
        new Modal(modal);
    });

    const alerts = Array.prototype.slice.call(document.querySelectorAll('[data-alert]')) as HTMLElement[];
    alerts.forEach(alert => {
        new Alert(alert);
    });

    const panels = [].slice.call(document.querySelectorAll('[data-panel]')) as HTMLElement[];
    panels.forEach(panel => {
        new RevealPanel(panel);
    });

    const siteSearchContainer = document.querySelector('#site-search-container') as HTMLElement;
    if (siteSearchContainer) {
        new SiteSearch(siteSearchContainer);
    }

    const accordions = [].slice.call(document.querySelectorAll('[data-accordion-list]')) as HTMLElement[];
    accordions.forEach(accordionEl => {
        const oneOpenAtATime = accordionEl.getAttribute('data-one-open-at-a-time') == "true";
        new Accordion({ container: accordionEl, oneOpenAtATime: oneOpenAtATime });
    });

    const tabEls = Array.prototype.slice.call(document.querySelectorAll('[data-tabs-container]')) as HTMLElement[];
    tabEls.forEach(tabEl => {
        new Tabs({ container: tabEl });
    })

    const autoplayVideoHandler = Array.prototype.slice.call(document.querySelectorAll('[data-autoplay-video-container]')) as HTMLElement[];
    autoplayVideoHandler.forEach(container => {
        const video = container.querySelector('video') as HTMLVideoElement;
        const videoLoader = new HTMLVideoLoader(video);
        const fallbackImage = container.parentNode.querySelector('[data-autoplay-fallback]') as HTMLElement;

        const videoPlayState = video.play();

        if (videoPlayState !== undefined) {
            const playBtn = container.parentNode.querySelector('[data-play-btn]') as HTMLButtonElement;

            videoPlayState.then(_ => {
            }).catch(error => {
                setTimeout(() => {
                    playBtn.style.display = 'block';
                }, 300)
            });
        }

        new AutoplayVideo({
            videoContainer: container,
            videoLoader,
            autoPlayFailCallback: () => {
                if (!video) {
                    container.style.display = 'none';
                    fallbackImage.style.display = 'block';
                }
            }
        });
    });


    const brandVideos = Array.prototype.slice.call(document.querySelectorAll('[data-brand-video-container]')) as HTMLElement[];
    brandVideos.forEach(container => {
        new BrandVideo(container);
    });

    const fiftyFiftyBlocks = Array.prototype.slice.call(document.querySelectorAll('[data-fifty-fifty-block]')) as HTMLElement[];
    fiftyFiftyBlocks.forEach(block => {
        new FiftyFifty(block);
    });

    const galleryBlocks = Array.prototype.slice.call(document.querySelectorAll('[data-gallery-block]')) as HTMLElement[];
    galleryBlocks.forEach((galleryBlock) => {
        new Gallery(galleryBlock);
    });

    const recommendationBlocks = Array.prototype.slice.call(document.querySelectorAll('[data-recommendation-block]')) as HTMLElement[];
    recommendationBlocks.forEach((recommendationBlock) => {
        new Recommendation(recommendationBlock);
    });

    const steppers = Array.prototype.slice.call(document.querySelectorAll('[data-stepper]')) as HTMLElement[];
    steppers.forEach(stepper => {
        new Stepper(stepper, 1);
    });

    const toggletips = Array.prototype.slice.call(document.querySelectorAll('[data-toggletip]')) as HTMLElement[];
    toggletips.forEach(toggletip => {
        new Toggletip(toggletip);
    });
};

const initStateDropdowns = () => {
    const stateDropdown = document.querySelector('#State') as HTMLSelectElement;
    const countryDropdown = document.querySelector('#Country') as HTMLSelectElement;
    if (stateDropdown && countryDropdown) {
        new StateDropdown(stateDropdown, countryDropdown);
    }
}


const countryDropDownList = document.querySelectorAll<HTMLSelectElement>(".js-country");

countryDropDownList.forEach(countryDropDown => countryDropDown.addEventListener("change", (e) => {
    const selectedCountryId = parseInt(countryDropDown.value);
    const addressType = countryDropDown.getAttribute("data-address-type");
    AddressApi.getStatesForCountry(selectedCountryId).then(results => {
        updateStatesDropDown(results, addressType);
    });
}));



function updateStatesDropDown(states: Array<StateSummary>, addressType: string) {
    const stateDropDown = document.querySelector<HTMLSelectElement>(".js-state[data-address-type=" + addressType + "]");
    stateDropDown.innerHTML = '';
    if (states.length) {
        states.forEach(state => {
            var option = document.createElement('option');
            option.value = state.stateCode.toString();
            option.innerHTML = state.description;
            stateDropDown.appendChild(option);
        });
        stateDropDown.disabled = false;
    }
    else {
        stateDropDown.disabled = true;
    }
}

init();
initializeGenericComponents();
lazyPoster();
